import { createFileRoute } from '@tanstack/react-router';
import { CampaignConnectInstagram } from '@/pages';

/**
 * Campaign Connect Instagram Route (Protected)
 * Connection gate in the creator campaign flow.
 */
export const Route = createFileRoute('/_authenticated/campaign/$id/connect')({
  component: CampaignConnectInstagram,
});
